export default "__VITE_PUBLIC_ASSET__86e1e684__"